import AnimatedLogoColored from '../spinners/AnimatedLogoColored';

const FullpageAnimatedLogo = () => {
  return (
    <>
      <style>{'body{overflow:hidden}'}</style>
      <div className='bg-body fixed z-50 flex h-[calc(100svh)] w-full items-center justify-center overflow-hidden rounded-md py-20'>
        <AnimatedLogoColored />
      </div>
    </>
  );
};

export default FullpageAnimatedLogo;
